import { render, staticRenderFns } from "./MatchMakingModal.vue?vue&type=template&id=e63fb1a8&scoped=true&"
import script from "./MatchMakingModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./MatchMakingModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63fb1a8",
  null
  
)

export default component.exports